import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { hooks } from '@engelvoelkersamericas/common-story-ui';
import { fetchLogin, createTicket } from '../requests/index';
import { getSelectValue } from './AsyncSelectModal';
import { getConfirmation } from './AsyncModal';
import { DateTime } from 'luxon';

const { useGlobalDispatch, useProfileState } = hooks;

export default function HeroCarousel({ cmsBanners, appGroups }) {
  // let date = DateTime.now();
  // if (date) {
  //   console.log('Date UTC', date);
  //   console.log('Date Parse', date.toISO());
  // }

  const { country, apps, firstName, lastName } = useProfileState();
  const [currentIndex, setCurrentIndex] = useState();
  const globalDispatch = useGlobalDispatch();

  const displayBanners = useMemo(() => {
    if (cmsBanners && appGroups) {
      setCurrentIndex(0);

      return filterBanners(cmsBanners, country, appGroups);
    } else {
      return [];
    }
  }, [cmsBanners, appGroups]);

  useEffect(() => {
    const i = setInterval(setNextIndex, 5000);
    return () => clearInterval(i);
  }, []);

  function setNextIndex() {
    if (displayBanners.length) {
      setCurrentIndex((prevIndex) => {
        const newValue = prevIndex + 1;
        if (newValue >= displayBanners.length) return 0;
        else if (newValue < 0) return 0;
        return newValue;
      });
    }
  }

  async function handleBannerClick(event, bannerIndex) {
    const b = displayBanners[bannerIndex];
    if (b.linkedApp) {
      event.preventDefault();
      // do login flow for app
      // find the app and use it with the flow

      const app = apps.find((a) => a.name === b.linkedApp);
      if (!app) {
        if (!localStorage.getItem(b.lockTicketString)) {
          const { ok } = await getConfirmation(
            `World IPS has detected that you do not have a ${b.linkedApp} account, please confirm you would like one.`
          );
          if (ok) {
            await createTicket(
              `User Needs Access To ${b.linkedApp}`,
              `${firstName} + ${lastName} was trying to access ${b.linkedApp} but doesn't have the required account(s).`,
              'IPS BANNER'
            );
            localStorage.setItem(b.lockTicketString, 'true');
            globalDispatch({
              type: 'display message',
              payload: {
                type: 'notice',
                message:
                  'Thank you. You will receive a confirmation within 24 hours of your account.',
              },
            });
          }
        } else {
          // globalDispatch({
          //   type: 'display message',
          //   payload: {
          //     type: 'Error',
          //     message:
          //       'Could not login. A ticket was already made to help resolve the issue.',
          //   },
          // });
        }

        return;
      }
      const { accounts, isReliance, name } = app;
      let relianceId;

      if (isReliance) {
        try {
          if (accounts?.length > 1) {
            const selected = await getSelectValue(
              'Select an account to use.',
              accounts.map((account) => ({
                value: account,
                id: account.id,
                label: account.label,
              }))
            );
            relianceId = selected.id;
          } else if (accounts?.length === 1) {
            relianceId = accounts[0].id;
          } else {
            // use reliance account id on staff table
          }
        } catch (error) {
          // closed the modal without selection
          return;
        }
      }
      try {
        globalDispatch({ type: 'set global loading', payload: true });
        await fetchLogin(name, relianceId);
        // globalDispatch({ type: 'set global loading', payload: false });
      } catch (error) {
        // need to do something with error
      }

      globalDispatch({ type: 'set global loading', payload: false });
    }
  }

  const currentBanner = displayBanners[currentIndex];
  return (
    <Container>
      <ParentImagesContainer>
        <ImagesContainer
          pointer={!!currentBanner?.outsideLink || !!currentBanner?.linkedApp}
        >
          {displayBanners &&
            displayBanners.map((banner, i) => (
              <a
                key={i}
                href={currentBanner?.outsideLink || undefined}
                target='_blank'
                rel='noopener noreferrer'
              >
                <ImageContainer
                  currentIndex={currentIndex}
                  onClick={(event) => handleBannerClick(event, i)}
                >
                  <img src={banner.image.url} alt={banner.name} />
                </ImageContainer>
              </a>
            ))}
        </ImagesContainer>
      </ParentImagesContainer>
      <DotsContainer>
        {displayBanners.map((_, index) => {
          return (
            <button
              onClick={() => setCurrentIndex(index)}
              key={index}
              className={`dot ${currentIndex === index ? 'active' : ''}`}
            ></button>
          );
        })}
      </DotsContainer>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
  .dot {
    padding: 0;
    margin: 6px 8px;
    width: 12px;
    height: 12px;
    border-radius: 15px;
    border: 1px solid #666666;
    transition: 1s ease-in-out;
    background-color: white;
    cursor: pointer;
  }
  .active {
    background-color: #666666;
  }
`;
const ParentImagesContainer = styled.div`
  position: relative;
`;
const ImagesContainer = styled.div`
  width: 100%;
  height: 100%;

  overflow: hidden;
  white-space: nowrap;
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'auto')};
`;
const ImageContainer = styled.div`
  display: inline-block;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${({ currentIndex }) => -100 * currentIndex}%);

  img {
    width: 100%;
    height: 100%;
    /* max-height: 278px; */
  }
`;

function filterBanners(cmsBanners, country, appGroups) {
  const activeFiltered = filterBannersByActive(cmsBanners);
  const dateFiltered = filterBannersByDate(activeFiltered);
  const countryFiltered = filterBannersByCountry(dateFiltered, country);
  const appFiltered = filterBannersByApp(countryFiltered, appGroups);
  return appFiltered;
}

function filterBannersByActive(list) {
  return list.filter((banner) => banner.active);
}

function filterBannersByDate(list) {
  return list.filter(
    (banner) =>
      DateTime.fromISO(banner.startDate) <= DateTime.now() &&
      DateTime.fromISO(banner.endDate) >= DateTime.now()
  );
}
//lux
function filterBannersByCountry(list, country) {
  let bannersByCountry = [];
  if (!country) {
    bannersByCountry = list;
  } else {
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].countries.length; j++) {
        if (
          (list[i].countries[j].country === country.replace(/\s/g, '') ||
            list[i].countries[j].country === 'All') &&
          !bannersByCountry.includes(list[i])
        ) {
          bannersByCountry.push(list[i]);
          break;
        }
      }
    }
  }

  return bannersByCountry;
}

function filterBannersByApp(list, appGroups) {
  const apps = [];
  for (const key in appGroups) {
    for (let i = 0; i < appGroups[key].apps.length; i++) {
      if (!apps.includes(appGroups[key].apps[i].name)) {
        apps.push(appGroups[key].apps[i].name);
      }
    }
  }

  const filteredBanners = [];
  for (let i = 0; i < list.length; i++) {
    if (
      (!list[i].linkedApp || apps.includes(list[i].linkedApp)) &&
      !filteredBanners.includes(list[i])
    ) {
      filteredBanners.push(list[i]);
    }
  }

  return filteredBanners;
}
